import SubSystemType from 'SubSystemType';
import BaseServiceRequestIIS from 'BaseServiceRequestIIS';

class FindGetDatagraphRequest extends BaseServiceRequestIIS {
    constructor() {
        super();
    }

    getServiceMethod() {
        return "FindGetDataGraph";
    }
    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return 'FindGetDataGraphReply';
    }
}

export default FindGetDatagraphRequest;